import React, { useCallback, useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import "./sports.scss";
//import * as classes from "../../components/Header/Topheader/Topheader.module.scss";
import * as classes from "../../components/Header/Topheader/Topheader.module.scss";
import themeChanger from "../../themeHandle/themeSwitcher";
import { navigate } from "@reach/router";
import { Dropdown } from "react-bootstrap";
import { Nav, Navbar, NavDropdown, Offcanvas } from "react-bootstrap";
import {
  getCookieData,
  getLocalstoreData,
  getSessionstoreData,
} from "../../Store/GetData";
import {
  DeleteCookie,
  DeleteLocalstore,
  DeleteSessionstore,
} from "../../Store/DeleteData";
import { Localstore, Sessionstore } from "../../Store/StoreData";
import {
  CategoryData,
  FailureModalShow,
  handleBENE_UserData,
  handleEndorse_UserData,
  SubCategory,
  UpdateCart,
  Userdata,
} from "../../Store/Action/Action";
import { useDispatch, useSelector } from "react-redux";
import { getallsubCategories, getProfileInfo } from "../../services/services";
import Link from "../../services/utility";
import { homepage } from "../../services/SEOServices";
import Faq from "../../components/Acedamycomponets/FAQS";
import AcedamyHeading from "../../components/Acedamycomponets/Acedamyheading";
//import { SportsCarousel } from "../../components/OtherComponents";
import Blogcarousel from "../../components/Acedamycomponets/blogsCarousel";
import EnroleButton from "../../components/Acedamycomponets/EnroleButton";

function SportsHeading() {
  const subCategoryData = useSelector((state) => state.subcategory);
  const categorydata = useSelector((state) => state.category);
  const userdata = useSelector((state) => state.data);
  const cartValue = useSelector((state) => state.cartData);
  var theme = getLocalstoreData("Theme");
  let userDetails = getLocalstoreData("userdata");
  const dispatch = useDispatch();
  const [SubCategories, setSubCategories] = useState([]);
  const [Categories, setCategories] = useState();
  const [navExpand, setnavExpand] = useState(false);
  const AccessToken = getCookieData("customer_access_token");
  const [SEOData, setSEOData] = useState({});
  const [cmsData, setcmsData] = useState();

  useEffect(() => {
    homepage();
    if (
      getCookieData("individual_token") !== undefined ||
      getCookieData("customer_access_token") !== undefined ||
      getCookieData("corporate_token") !== undefined
    ) {
      getProfileInfo()
        .then((response) => {
          if (response.data.success) {
            dispatch(Userdata(response.data.data));
            Localstore("userdata", response.data.data);
          } else {
            dispatch(
              FailureModalShow({
                show: true,
                msg: response.data.message,
              })
            );
          }
        })
        .catch((error) => {
          dispatch(
            FailureModalShow({
              show: true,
              msg: error.message,
            })
          );
        });
    }
  }, []);

  const getSubCategory = () => {
    getallsubCategories()
      .then((response) => {
        const result = response.data.data;

        var filteredArray = result.reduce((unique, o) => {
          if (!unique.some((obj) => obj.category_id === o.category_id)) {
            unique.push(o);
          }
          return unique;
        }, []);

        var resultData = filteredArray.map(function (item) {
          return {
            id: item.listing_category.id,
            name: item.listing_category.category_name,
          };
        });
        Sessionstore("CategoryData", resultData);
        dispatch(CategoryData(resultData));
        setCategories(resultData);
        function groupBy(arr, property) {
          return result.reduce(function (memo, x) {
            if (!memo[x[property]]) {
              memo[x[property]] = [];
            }
            memo[x[property]].push(x);
            return memo;
          }, []);
        }
        var resultArray = groupBy(result, "category_id");
        dispatch(SubCategory(resultArray));
      })
      .catch((error) => {
        dispatch(
          FailureModalShow({
            show: true,
            msg: error.message,
          })
        );
      });
  };

  const Category = useCallback(() => {
    if (getCookieData("benefitiory_user") !== undefined) {
      dispatch(handleBENE_UserData(getCookieData("benefitiory_user")));
      dispatch(handleEndorse_UserData(getCookieData("endoser_data")));
    }
    const user = getLocalstoreData("userdata");
    dispatch(Userdata(user));
    if (categorydata.length === 0 && subCategoryData.length === 0) {
      var CurrentTheme = getLocalstoreData("Theme");

      themeChanger(CurrentTheme);
      if (
        typeof window !== "undefined" ||
        getSessionstoreData("CategoryData") !== null
      ) {
        setCategories(getSessionstoreData("CategoryData"));
      }
      getSubCategory();
    }
  }, [dispatch]);

  useEffect(() => {
    Category();
  }, [Category]);

  const getSubCategories = (id) => {
    var filteredArray = subCategoryData.filter(function (item, index) {
      return index === id;
    });
    setSubCategories(filteredArray[0]);
  };

  return (
    <div>
      <div className="mainsec">
        <div className={classes.topsec} id="header">
          {/* Mobile menu start */}
          <div className={classes.mobileMenu}>
            <Navbar expand={false}>
              <Navbar.Toggle
                aria-controls="offcanvasNavbar"
                className={`onlyMob ${classes.mobMenu}`}
                onClick={() => {
                  getSubCategory();
                  setnavExpand(!navExpand);
                }}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="start"
              >
                {AccessToken === undefined ? (
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id="offcanvasNavbarLabel">
                      <Nav.Link
                        as={Link}
                        role="button"
                        aria-label="Sign in / Sign up"
                        // aria-title="Sign in / Sign up"
                        to="/Auth/"
                      >
                        Signin/Signup
                      </Nav.Link>
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                ) : (
                  <Offcanvas.Header closeButton className={classes.closeSec}>
                    <StaticImage
                      className={classes.profileImg}
                      alt="usericon"
                      //src="../../../assets/images/usericon.png"
                      src='../../assets/images/usericon.png'
                    ></StaticImage>
                    <Offcanvas.Title id="offcanvasNavbarLabel">
                      <Nav.Link>
                        <Link aria-label="Settings">
                          Hello {userdata?.first_name || "User"}
                        </Link>
                      </Nav.Link>
                    </Offcanvas.Title>
                    <span class="material-symbols-outlined">close</span>
                  </Offcanvas.Header>
                )}
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1  navDropdown">
                   <Nav.Link href="/Enrolemenu">
                      ENROLL
                    </Nav.Link>
                    <Nav.Link
                      onClick={() => {
                        if (theme === "light") {
                          theme = "dark";
                          Localstore("Theme", "dark");
                          themeChanger("dark");
                        } else {
                          theme = "light";
                          Localstore("Theme", "light");
                          themeChanger("light");
                        }
                      }}
                    >
                      CHANGE THEME
                    </Nav.Link>
                    {AccessToken !== undefined && (
                      <Nav.Link
                        href="/"
                        onClick={() => {
                          DeleteSessionstore("benefitary");
                          DeleteCookie("customer_access_token");
                          dispatch(UpdateCart([]));
                          Localstore("CartData", []);
                        }}
                      >
                        LOGOUT
                      </Nav.Link>
                    )}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Navbar>
          </div>
          {/* Mobile menu end */}

          <div
            className={classes.logo}
            tabIndex={0}
            role="img"
          /*   onKeyPress={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                navigate("/academy/sports/");
              }
            }}
            onClick={() => navigate("/academy/sports/")}
            aria-label="Ableaura logo home graphic link" */
          />
          {AccessToken !== undefined ||
          getCookieData("individual_token") !== undefined ||
          getCookieData("corporate_token") !== undefined ? (
            <Dropdown className={`onlyDes ${classes.userDropmenu}`}>
              <Dropdown.Toggle
                id="dropdown-autoclose-true"
                className="mainuserHeader countryDrop"
              >
                <span
                  // id="parent_service"
                  className="topnameSec"
                >
                  Hello
                  <p className="usernameSec">
                    {" " + userdata?.first_name === null
                      ? "User"
                      : userdata?.first_name || "User"}
                  </p>
                  <i
                    role="list"
                    aria-label="open account and menu options."
                    className="material-symbols-outlined"
                  ></i>
                 </span>
              </Dropdown.Toggle>

              <Dropdown.Menu role="list">
                <Dropdown.Item as={Link} to="/Enrolemenu">
                  ENROLL
                </Dropdown.Item>
                <Dropdown.Item
                  tabIndex="0"
                  onClick={() => {
                    if (theme === "light") {
                      theme = "dark";
                      Localstore("Theme", "dark");
                      themeChanger("dark");
                    } else {
                      theme = "light";
                      Localstore("Theme", "light");
                      themeChanger("light");
                    }
                  }}
                >
                  Change Theme
                </Dropdown.Item>
                <Dropdown.Item
                  tabIndex={0}
                  as="a"
                  aria-label="sign out"
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      DeleteCookie("customer_access_token");
                      DeleteLocalstore("userdata");
                      DeleteCookie("individual_token");
                      DeleteCookie("corporate_token");
                      DeleteCookie("benefitiory_user");
                      dispatch(UpdateCart([]));
                      Localstore("CartData", []);
                      Localstore("userdata", null);
                      window.location.assign("/Auth");
                    }
                  }}
                  onClick={() => {
                    DeleteCookie("customer_access_token");
                    DeleteLocalstore("userdata");
                    DeleteCookie("individual_token");
                    DeleteCookie("corporate_token");
                    DeleteCookie("benefitiory_user");
                    dispatch(UpdateCart([]));
                    Localstore("CartData", []);
                    Localstore("userdata", null);
                    window.location.assign("/Auth");
                  }}
                >
                  Signout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <div role="none" className={`onlyDes ${classes.userDropmenu}`}>
              <Link
                to="/Auth/"
                onClick={() => {
                  Sessionstore("benefitary", 4);
                  DeleteCookie("customer_access_token");
                  dispatch(handleEndorse_UserData(null));
                }}
              >
                Signin/Signup
              </Link>
          </div>
          )}
        </div>
        </div>
    </div>
  );
}

export default SportsHeading;